var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-alert",class:_vm.rootClass},[_c('div',{staticClass:"base-alert__icon"},[_c('BaseIcon',{attrs:{"glyph":_vm.currentIcon}})],1),_c('div',{staticClass:"base-alert__content typography"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }